import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-app-online-payment-failed',
  templateUrl: './app-online-payment-failed.component.html',
  styleUrls: ['./app-online-payment-failed.component.scss']
})
export class AppOnlinePaymentFailedComponent implements OnInit {

  constructor(private router: Router, private aRoute: ActivatedRoute) { }

  ngOnInit(): void {
  }

  tryAgain(){
    this.router.navigate(['/', 'home']);
  }

}
